const milestones = [
  {
    year: '1992',
    title: 'Gründung von gowiTEC',
    description:
      'Hans-Jörg Gollan gründet gowiTEC als Einzelunternehmen im Bergischen Land. Fokus auf Steuerungstechnik und individuelle Maschinenlösungen für regionale Industriekunden.',
  },
  {
    year: '2000',
    title: 'Erweiterung auf SPS-Systeme',
    description:
      'Ausbau der Kompetenzen im Bereich SPS-Programmierung (Siemens, Beckhoff). Erste größere Automatisierungsprojekte für mittelständische Produktionsbetriebe.',
  },
  {
    year: '2008',
    title: 'Sondermaschinenbau & Handling',
    description:
      'Erweiterung des Leistungsportfolios um Sondermaschinenbau und Handlingsysteme. Realisierung komplexer Transfersysteme und pneumatischer Automatisierungsanlagen.',
  },
  {
    year: '2012',
    title: 'Zertifizierter Robotik-Systemintegrator',
    description:
      'gowiTEC wird zertifizierter Systemintegrator für Industrieroboter. Damit erweitert sich das Angebot um professionelle Roboterintegration und Roboteranwendungen in der Industrie.',
  },
  {
    year: '2015',
    title: 'Loxone Partner & Gebäudeautomation',
    description:
      'Partnerschaft mit Loxone: gowiTEC bietet nun auch Gebäudeautomation und Sicherheitstechnik an – von der Planung bis zur schlüsselfertigen Installation.',
  },
  {
    year: 'Heute',
    title: 'Über 500 realisierte Projekte',
    description:
      'Mit über 30 Jahren Erfahrung und mehr als 500 realisierten Projekten ist gowiTEC ein verlässlicher Partner für Industrie und Mittelstand in ganz Deutschland und Europa.',
  },
];

const CompanyHistory = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Firmengeschichte</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4">
            Unsere Geschichte
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            Von der Gründung 1992 bis heute – ein Unternehmen, das mit seinen Kunden gewachsen ist.
          </p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gray-200 hidden md:block" />

          <div className="flex flex-col gap-12">
            {milestones.map((m, i) => (
              <div
                key={m.year}
                className={`relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-0 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Text side */}
                <div className={`w-full md:w-[calc(50%-2.5rem)] ${i % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`}>
                  <div className="bg-[#F8FAFC] border border-gray-100 rounded-xl p-6 hover:border-[#1E3A8A]/20 transition-colors duration-200">
                    <span className="text-[#1E3A8A] text-xs font-bold tracking-widest uppercase">{m.year}</span>
                    <h3 className="text-gray-900 font-semibold text-lg mt-1 mb-2">{m.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
                  </div>
                </div>

                {/* Center dot */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-10 h-10 items-center justify-center bg-[#1E3A8A] rounded-full shrink-0 z-10">
                  <i className="ri-map-pin-line text-white text-sm"></i>
                </div>

                {/* Empty side */}
                <div className="hidden md:block w-[calc(50%-2.5rem)]" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
